/**
 * sends an error to the defined output
 *
 * @param {error} error the error to be sent
 *
 */
function log(error) {
  console.error(error);
}

export { log };
